import { apiRequest } from '@/integrations/api/client';

export interface AppNotification {
  id: string;
  tenant_id: string | null;
  category: 'iam' | 'account' | 'security';
  type: string;
  title: string;
  body: string | null;
  link: string | null;
  payload: Record<string, unknown>;
  read_at: string | null;
  created_at: string;
}

export interface NotificationPreferences {
  email_iam: boolean;
  email_account: boolean;
  email_security: boolean;
  in_app_iam: boolean;
  in_app_account: boolean;
  in_app_security: boolean;
  updated_at: string;
}

export async function fetchNotifications(unreadOnly = false) {
  const q = unreadOnly ? '?unread_only=true' : '';
  const res = await apiRequest<{ notifications: AppNotification[] }>(`/api/notifications${q}`);
  return res.notifications;
}

export async function markNotificationRead(id: string) {
  return apiRequest<{ notification: AppNotification }>(`/api/notifications/${id}/read`, {
    method: 'PATCH',
  });
}

export async function markAllNotificationsRead() {
  return apiRequest('/api/notifications/read-all', { method: 'POST' });
}

export async function fetchNotificationPreferences() {
  const res = await apiRequest<{ preferences: NotificationPreferences }>(
    '/api/notifications/preferences',
  );
  return res.preferences;
}

export async function updateNotificationPreferences(
  patch: Partial<NotificationPreferences>,
) {
  const res = await apiRequest<{ preferences: NotificationPreferences }>(
    '/api/notifications/preferences',
    { method: 'PATCH', body: patch },
  );
  return res.preferences;
}
